import { EditMeRequest, MeDto, useUpdateMeMutation } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { useCreateEditor, useSaveNow } from "../../../common/editing/save-coordinator";
import { useAppDispatch } from "../../../common/redux/hooks";
import { updateMe } from "../../../common/redux/reducers/authStateReducer";

export const useCreateMeEditor = (): void => {
  const { me } = useLoggedInWithOrgContextState();
  const dispatch = useAppDispatch();
  const [editMe] = useUpdateMeMutation();
  useCreateEditor<MeDto, EditMeRequest>(me.id, {
    initialState: me,
    save: async (fields) => {
      const updated = await editMe({ editMeRequest: fields }).unwrap();
      dispatch(updateMe(updated));
      return updated;
    },
  });
};

export const useSaveMe = (): { saveMe: (patch: EditMeRequest) => Promise<void>; isSaving: boolean } => {
  const { me } = useLoggedInWithOrgContextState();
  const { saveNow, isSaving } = useSaveNow<MeDto, EditMeRequest>(me.id);
  return { saveMe: saveNow, isSaving };
};
